import { AnyAction } from '@reduxjs/toolkit';
import { SET_ACCOUNT_MANAGER } from '../action-types';
import type { ISetAccountManagerAction } from '../actions';
import type { TCustomerUserOrEmpty } from '../interfaces';

export const customerAccountManagerReducer = (
  state: TCustomerUserOrEmpty = {},
  action: AnyAction,
): TCustomerUserOrEmpty => {
  switch (action.type) {
    case SET_ACCOUNT_MANAGER: {
      return {
        ...(action as ISetAccountManagerAction).payload,
      };
    }
    default:
      return state;
  }
};
